import modalLayer from '../modal'
import ConfirmModal, { IConfirmModalProps } from './ConfirmModal'

const deferred = () => {
  const result: any = {}
  result.promise = new Promise((resolve, reject) => {
    result.resolve = resolve
    result.reject = reject
  })
  return result
}

export interface IConfirmProps extends IConfirmModalProps {}

const confirmLayer = (options: IConfirmProps) => {
  const d = deferred()
  modalLayer(ConfirmModal, { ...options }, 'confirmModal')
    .then(() => {
      d.resolve()
    })
    .catch(async () => {
      d.reject()
    })

  return d.promise
}

export default confirmLayer
